module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "merch-section",
    attrs: {
      "xs12": "",
      "sm12": "",
      "id": "carousel-view"
    }
  }, [_c('v-layout', {
    staticClass: "dismiss-section",
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "image-section",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [(_vm.covers.length > 1) ? _c('v-carousel', {
    staticClass: "product-carousel"
  }, _vm._l((_vm.covers), function(cover, index) {
    return _c('v-carousel-item', {
      key: index,
      attrs: {
        "src": cover.cover.large.url,
        "transition": "fade",
        "reverseTransition": "fade"
      },
      on: {
        "onmouseout": function($event) {
          _vm.zoomOut()
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.covers.length == 1) ? _c('div', {
    staticClass: "product-cover-image",
    style: ({
      'background-image': 'url(' + _vm.covers[0].cover.url + ')',
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.covers.length) ? _c('div', {
    staticClass: "product-cover-image"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "info-section",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.item.merchant,
      "className": 'avatar-image'
    }
  }), _vm._v(" "), (_vm.item.collaborators_count == 0) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.merchant.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])], 1) : _c('div', {
    staticClass: "profile-content"
  }, [_c('div', {
    staticClass: "profile-title"
  }, [_vm._v("Multiple Collaborators")]), _vm._v(" "), _c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": ("/" + (_vm.item.merchant.slug))
    }
  }, [_vm._v(_vm._s(_vm.item.merchant.username))]), _vm._v(" "), _vm._l((_vm.item.collaborators), function(c) {
    return [_vm._v("\n            , "), _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (c.user.slug))
      }
    }, [_vm._v(_vm._s(c.user.username))])]
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('p', {
    staticClass: "item-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.price)))]), _vm._v(" "), _c('p', {
    staticClass: "item-description"
  }, [_vm._v(_vm._s(_vm.item.description))])])], 1) : _vm._e(), _vm._v(" "), (_vm.showPolicySection) ? _c('v-flex', {
    staticClass: "policy-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _c('v-tabs-item', {
    key: "size_chart",
    attrs: {
      "href": "#size_chart"
    }
  }, [_vm._v("Size Chart")]), _vm._v(" "), _c('v-tabs-item', {
    key: "shipping_policy",
    attrs: {
      "href": "#shipping_policy"
    }
  }, [_vm._v("Shipping Policy")]), _vm._v(" "), _c('v-tabs-item', {
    key: "return_policy",
    attrs: {
      "href": "#return_policy"
    }
  }, [_vm._v("Return Policy")]), _vm._v(" "), _c('v-tabs-item', {
    key: "privacy_policy",
    attrs: {
      "href": "#privacy_policy"
    }
  }, [_vm._v("Privacy Policy")])], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    key: "size_chart",
    attrs: {
      "id": "size_chart"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.size_chart))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "shipping_policy",
    attrs: {
      "id": "shipping_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.shipping_policy))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "return_policy",
    attrs: {
      "id": "return_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.return_policy))])], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    key: "prviacy_policy",
    attrs: {
      "id": "privacy_policy"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._v(_vm._s(_vm.item.merchant.privacy_policy))])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "actions-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('a', {
    staticClass: "action-btn right-border",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.togglePolicy()
      }
    }
  }, [_vm._v(_vm._s(_vm.policyButtonText))]), _vm._v(" "), _c('a', {
    staticClass: "action-btn right-border",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.repostProduct()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "padding-top": "3px"
    },
    attrs: {
      "width": "24px",
      "height": "20px",
      "viewBox": "0 0 24 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "23---Merch-Modal",
      "transform": "translate(-818.000000, -773.000000)",
      "fill": "#3A92FF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(460.000000, 240.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(177.000000, 529.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M203.353452,13.450486 C203.842994,13.420565 204.283792,13.7701682 204.323209,14.2639522 C204.332359,14.3817114 204.530322,17.1267443 202.64096,19.1604973 C201.389831,20.5064173 199.561882,21.1561054 197.207789,21.1561054 L186.388782,21.1561054 L186.388782,23.5503101 C186.388782,23.723362 186.19645,23.8813659 186.039135,23.9560809 C185.97737,23.9860019 185.818648,24 185.752308,24 C185.650775,24 185.549945,23.9657046 185.467769,23.8999134 L181.643996,20.8232999 C181.538064,20.7380863 181.476123,20.6098284 181.476123,20.4736966 C181.476123,20.3373899 181.538064,20.209132 181.643996,20.1239184 L185.467769,17.0473049 C185.603088,16.9393444 185.882876,16.9155475 186.039135,16.9911374 C186.19645,17.0658524 186.388782,17.2240313 186.388782,17.3970831 L186.388782,19.581316 L197.207789,19.581316 C199.02958,19.581316 200.406525,19.0126421 201.301144,18.0576198 C202.654685,16.6124881 202.520422,14.4555516 202.519015,14.4343794 C202.483645,13.9398955 202.85652,13.4874061 203.353452,13.450486 Z M181.979719,14.5451396 C181.490354,14.5748856 181.049379,14.2275571 181.010139,13.7337731 C181.000812,13.6160139 180.802849,10.8543582 182.692212,8.82043027 C183.94334,7.47451028 185.77129,6.80802443 188.125382,6.80802443 L198.934183,6.80802443 L198.934183,4.44968985 C198.934183,4.276638 199.131619,4.11845916 199.288933,4.04391913 C199.350698,4.01399813 199.5147,4 199.580863,4 C199.682573,4 199.783226,4.03412044 199.865403,4.10008661 L203.689176,7.17670012 C203.795284,7.26191372 203.857048,7.39017156 203.857048,7.52630336 C203.857048,7.66243515 203.795284,7.79069299 203.689176,7.87608157 L199.865403,10.9525201 C199.73026,11.0606556 199.445369,11.0844525 199.288933,11.0088626 C199.131619,10.9341476 198.934183,10.7759687 198.934183,10.6029169 L198.934183,8.3828138 L188.125382,8.3828138 C186.303591,8.3828138 184.926646,8.96951033 184.032204,9.92435762 C182.678662,11.3696643 182.812925,13.5355246 182.814157,13.5565218 C182.849526,14.0511807 182.476651,14.5082195 181.979719,14.5451396 Z",
      "id": "ic_repeat"
    }
  })])])])])]), _vm._v("\n        Repost this product\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.shareProduct()
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "padding-top": "3px"
    },
    attrs: {
      "width": "15px",
      "height": "20px",
      "viewBox": "0 0 19 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "23---Merch-Modal",
      "transform": "translate(-1090.000000, -771.000000)",
      "fill-rule": "nonzero",
      "fill": "#3A92FF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(460.000000, 240.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(177.000000, 529.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-23",
      "transform": "translate(453.000000, 2.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00415315,3.25693396 L1.70710678,9.55398033 C1.31658249,9.94450462 0.683417511,9.94450462 0.292893219,9.55398033 C-0.0976310729,9.16345604 -0.0976310729,8.53029106 0.292893219,8.13976677 L8.13976677,0.292893219 C8.53029106,-0.0976310729 9.16345604,-0.0976310729 9.55398033,0.292893219 L17.7919553,8.53086817 C18.1824796,8.92139246 18.1824796,9.55455744 17.7919553,9.94508173 C17.401431,10.335606 16.768266,10.335606 16.3777417,9.94508173 L10.0097727,3.57711275 L10.2200725,16.1756106 C10.2086891,19.7571806 12.3351533,21.4625058 17.0734141,21.4692941 C17.6256983,21.4700854 18.0727716,21.9184416 18.0719804,22.4707258 C18.0711892,23.02301 17.6228329,23.4700833 17.0705488,23.4692921 C11.3129674,23.4610434 8.20482908,20.9684614 8.22021711,16.1891374 L8.00415315,3.25693396 Z",
      "id": "Combined-Shape"
    }
  })])])])])])]), _vm._v("\n        Share this product\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99b40986","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/payments/components/product.vue
// module id = 1819
// module chunks = 180